module.exports = Jsw.skinUrl + "/icons/16/plesk/file-webscript.png?b2aff14c14b05cccbb316c37d48fb591";